import React, {PureComponent} from 'react';
import classNames from 'classnames';
import {gettext} from '../../../translations';

import Button from 'eventbrite_design_system/button/Button';

import {getTabId, getPanelId} from '../util';

import '../tabs.scss';

export default class TabItem extends PureComponent {
    componentDidUpdate(prevProps) {
        const {isSelected: wasSelected} = prevProps;
        const {isSelected} = this.props;

        if (!wasSelected && isSelected) {
            this._selectedTab.focus();
        }
    }

    _getRef(ref) {
        this._selectedTab = ref;
    }

    render() {
        const {
            value,
            displayName,
            onSelected,
            isSelected,
        } = this.props;

        const tabItemClasses = classNames(
            'eds-tabs__item',
            'eds-l-pad-hor-2',
            'eds-l-md-pad-hor-3',
            'eds-l-mw-pad-hor-4',
            'eds-l-ln-pad-hor-4',
            'eds-l-lg-pad-hor-4',
            'eds-l-lw-pad-hor-4',
            {
                'eds-tabs__item--selected': isSelected,
            }
        );

        const tabItemLinkClasses = classNames(
            'eds-tabs__item-link',
            'eds-l-pad-vert-3'
        );

        let controlledPanel;

        let selectedMessage = '';

        if (isSelected) {
            controlledPanel = getPanelId(value);
            selectedMessage = ' Selected category.';
        }

        return (
            <li
                id={getTabId(value)}
                className={tabItemClasses}
                aria-controls={controlledPanel}
            >
                <Button
                    ref={this._getRef.bind(this)}
                    style="none"
                    __containerClassName={tabItemLinkClasses}
                    onClick={onSelected}
                    data-spec={`tab-link--${value}`}
                    data-automation={`tab-link--${value}`}
                    aria-label={gettext(`Filter by ${displayName} events.${selectedMessage}`)}
                >
                    <span className="eds-text-weight--heavy">{displayName}</span>
                </Button>
            </li>
        );
    }
}
